import { render, staticRenderFns } from "./diagnosisTime.vue?vue&type=template&id=3c5dfd48&scoped=true"
import script from "./diagnosisTime.vue?vue&type=script&lang=ts"
export * from "./diagnosisTime.vue?vue&type=script&lang=ts"
import style0 from "./diagnosisTime.vue?vue&type=style&index=0&id=3c5dfd48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5dfd48",
  null
  
)

export default component.exports